<template>
  <div class="space-holder" :style="spaceHeight"></div>
</template>

<script>
export default {
  name: 'SpaceHolder',
  props: {
    spaceheight: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      spaceHeight: `height: ${this.spaceheight}px`
    }
  }
}
</script>

<style lang="stylus" scoped>
.space-holder
  width 100%
  padding-top 5px
  margin-bottom 5px
  background #fff
  opacity 0
</style>
